import type { Channel, PausedChannels } from "../types/outreach.types"

export function isChannelPaused(paused: PausedChannels | undefined, channel: Channel): boolean {
  return paused === "ALL" || paused === channel
}

/** The paused_channels value after turning one channel's pause on or off. */
export function channelsAfterToggle(
  current: PausedChannels | undefined,
  channel: Channel,
  paused: boolean,
): PausedChannels {
  const call = channel === "CALL" ? paused : isChannelPaused(current, "CALL")
  const sms = channel === "SMS" ? paused : isChannelPaused(current, "SMS")
  if (call && sms) return "ALL"
  if (call) return "CALL"
  if (sms) return "SMS"
  return null
}

export const CHANNEL_LABEL: Record<Channel, string> = { CALL: "Calls", SMS: "Texts" }
